
import React, { useState, useMemo, useEffect } from 'react'
import { NotFound } from '../../components/common/NotFound';
import TableGrid from '../../components/common/TableGrid';
import { Pagination } from '../../components/common/Pagination';
import Spinner from "../../components/common/Spinnner";
import { useSortableTable } from "../../hooks/useSortableTable";
import SkeletonListingGrid from './skeletonListingPage';

const DataTable = (props) => {

    const [count, setCount] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = count;

    const {
        filteredResults,
        filterColumn,
        handleEdit,
        handleDelete,
        handleView,
        loading,
        menuRights,
        moduleName } = props

    const { items, requestSort, sortConfig, setItems } = useSortableTable(filteredResults);


    const currentTableData = useMemo(() => {
        if (items?.length <= pageSize) setCurrentPage(1);
        else if (currentPage > Math.ceil(items?.length / pageSize)) {
            setCurrentPage(1);
        }

        const firstPageIndex = (currentPage - 1) * pageSize;
        const lastPageIndex = firstPageIndex + pageSize;
        return items?.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, items, count]);

    return (
        <>
            {/* <!-- table-sec starts --> */}
            {
                currentTableData.length > 0 ?
                    <section className="table-sec">
                        <div className="row">
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                                <div className="currency-table-wrapper">
                                    <table className="table table-striped table-borderless mb-0">
                                        {
                                            currentTableData?.length > 0 ?
                                                <TableGrid
                                                    requestSort={requestSort}
                                                    sortConfig={sortConfig}
                                                    //  items={items}
                                                    items={currentTableData}
                                                    column={filterColumn}
                                                    moduleName={moduleName}
                                                    handleEdit={handleEdit}
                                                    handleDelete={handleDelete}
                                                    menuRights={menuRights}
                                                    handleView={handleView}
                                                />
                                                : loading === true ? <>
                                                    {Array.from({ length: 10 }).map((_, index) => (
                                                        <SkeletonListingGrid key={index} />
                                                    ))}
                                                </> : <NotFound />
                                        }

                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    loading === true ? <>
                        {Array.from({ length: 10 }).map((_, index) => (
                            <SkeletonListingGrid key={index} />
                        ))}
                    </> : <NotFound />
            }
            {/* <!-- table-sec ends --> */}

            {/* pagination-sec */}

            {/* pagination-sec start */}
            <section className='pagination-sec d-none'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='pagination-d-flex d-flex align-items-center justify-content-between'>
                                    <div className='d-flex align-items-baseline'>
                                        <p className='mr-2'>Show</p>
                                        <select className='form-control mr-2' value={count} onChange={e => setCount(Number(e.target.value))}>
                                            {[10, 25, 50].map(Count => (
                                                <option key={Count} value={Count}>{Count}</option>))
                                            }
                                        </select>
                                        <p>1 - 10 of 50 Entries</p>
                                    </div>
                                    <nav aria-label="Page navigation example" className='ml-4'>
                                        <Pagination
                                            className="pagination-bar pl-0"
                                            currentPage={currentPage}
                                            totalCount={items.length}
                                            pageSize={pageSize}
                                            onPageChange={page => setCurrentPage(page)} />
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* pagination-sec end */}
        </>

    )
}

export default DataTable